var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('diet-schedules-list',{attrs:{"meta":_vm.meta,"id":_vm.id,"type":_vm.type,"initialDayID":_vm.initialDayID,"programDetails":_vm.ProgramDetails.data}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5e9e5960","hasScoped":false,"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/professional/programs/diets/details/shedules/page-diet-schedules.vue
// module id = 3124
// module chunks = 0